import React, { Component } from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarDistritoDs } from "../DataSources";
import uiInfo from "../ui-info";
import UserInfo from "../UserInfo";

export default class DistritosBox extends Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        console.log("Render bairro");
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="DISTRITOS">
                        <DataGrid
                            dataSource={criarDistritoDs()}
                            showBorders={true}
                            rowAlternationEnabled={true} remoteOperations={true}
                            focusedRowEnabled={true}
                            onInitNewRow={this.initNewRow}>
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                            <Column dataField={"id"} visible={false} />
                            <Column dataField={'sequencial'} allowEditing={false} />
                            <Column dataField={'descricao'} />
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={uiInfo.tamanhoPaginaOpcoes}
                                allowedPageSizes={uiInfo.tamanhoPaginaPadrao}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}
